<template>
   <v-flex pb-0 pt-1 v-bind="$attrs" xs12>
      <v-text-field :browser-autocomplete="'nope'" :placeholder="pholder" :rules="validationRules" :value="value"
                    ref="aField" return-masked-value box
                    v-bind="$attrs" class="clean-style"
                    v-on="listeners" validate-on-blur/>
   </v-flex>
</template>

<script>
   import Rules from './validationRules';

   export default {
      name: 'a-text-field',

      props: {
         value: {
            required: false
         },
         floating: {
            type: Boolean,
            required: false,
            default: false
         },
         align: {
            type: String,
            required: false,
            default: 'left'
         },
         textTransform: {
            type: String,
            required: false
         },
         validate: {
            type: String,
            required: false
         },
         customRule: {
            type: Function,
            required: false
         }

      },

      data () {
         return {
            rawInput: null
         };
      },

      computed: {
         listeners () {
            return {
               ...this.$listeners,
               input: (value) => {
                  if (value) {
                     if (this.textTransform === 'uppercase') {
                        value = value.toUpperCase();
                     } else if (this.textTransform === 'lowercase') {
                        value = value.toLowerCase();
                     } else if (this.textTransform === 'capitalize') {
                        value = value.toCapitalize();
                     }
                  }

                  this.$emit('input', value);
               }
            };
         },
         pholder () {
            let prop = this.placeholder;
            return (this.floating) ? (prop || '') : ' ';
         },
         validationRules () {
            let rules = [];

            if (this.validate) {

               let rulesArray = this.validate.split(',');
               rulesArray.forEach(r => rules.push(Rules[r.trim()]));
            }

            if (this.customRule) {
               rules.push(this.customRule);
            }

            return rules;
         },
         valid () {
            return this.$refs.aField.valid;
         },
         forceValidation () {
            return this.$refs.aField.validate;
         }
      },


      mounted () {
         this.rawInput = this.$el.querySelector('input');
         this.rawInput.style.textAlign = this.align;
         // console.log(this.$i18n.locale);
         // this.rawInput.style.textTransform = this.textTransform;

      }


   }
</script>

<style>


</style>


// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/components/ATextField.vue